import { render } from "./Payment.vue?vue&type=template&id=0442a11a&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import "./Payment.vue?vue&type=style&index=0&id=0442a11a&scoped=true&lang=css"
import "./Payment.vue?vue&type=style&index=1&id=0442a11a&scoped=true&lang=css"

import exportComponent from "/Users/fikri/Work/PRiADI/code/priadi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0442a11a"]])

export default __exports__